// import Home      from '../views/Home';
import Users     from '../views/Users';
import MenuItems from '../views/MenuItems';
import History   from '../views/History';
import Login     from '../views/Login';
import Offline   from '../views/Offline';
import Kiosk     from '../views/Kiosk';

export const routes = [
    // {
    //     path:      '/',
    //     name:      'home',
    //     component: Home,
    //     meta:      {requiresAuth: true}
    // },
    {
        path:      '/users',
        name:      'users',
        component: Users,
        meta:      {requiresAuth: true}
    },
    {
        path:      '/',
        name:      'menu-items',
        component: MenuItems,
        meta:      {requiresAuth: true}
    },
    {
        path:      '/history',
        name:      'history',
        component: History,
        meta:      {requiresAuth: true}
    },
    {
        path:      '/kiosk',
        name:      'kiosk',
        component: Kiosk,
        meta:      {requiresAuth: true}
    },
    {
        path:      '/login',
        name:      'login',
        component: Login,
        meta:      {requiresAuth: false}
    },
    {
        path:      '/offline',
        name:      'offline',
        component: Offline,
    },
    {
        path:     "*",
        redirect: {name: 'menu-items'}
    }
];
